import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';

export default function NavItem({ className = '', children = null, ...props }) {
  return (
    <UiKit.Button {...props} className={cn(styles.container, className)}>
      {children}
    </UiKit.Button>
  );
}
